<template>
  <div class="base-add-info">
    <div class="base-top-header">
      <div class="base-top-title">{{ infoTitle.title }}</div>
      <div class="base-top-button" @click="addEditInfo()" v-if="!disabled">
        新增
      </div>
    </div>
    <div class="base-item-box" v-for="(item, index) in dataList" :key="index">
      <div class="item-info">
        <div class="f1">
          <TextOverTooltip :content="getContent(item, 1)" />
        </div>
        <div class="tag-operate" @click="addEditInfo(item)" v-if="!disabled">
          <div class="icon-title">编辑</div>
          <div class="icon-box"></div>
        </div>
      </div>
      <div class="item-info">
        <div class="f1">
          <TextOverTooltip :content="getContent(item, 2)" />
        </div>
        <div class="f1">
          <TextOverTooltip :content="getContent(item, 3)" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { timeFormat } from "@/utils/baseFormat";
import TextOverTooltip from "@/components/overTooltip/index.vue";
export default {
  name: "BaseDddInfo",
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    //  type: 1 瞑眩反应 2 入药反应 3 新发症状 4 停/续药安排
    type: {
      type: Number,
      require: true,
      default: 1,
    },
    // 是否只读
    disabled: {
      type: Boolean,
      default: false,
    },
    // 疗程id
    treatmentId: {
      type: Number,
      require: true,
      default: 1,
    },
  },
  components: {
    TextOverTooltip,
  },
  data() {
    return {};
  },
  computed: {
    infoTitle() {
      return {
        1: {
          title: "瞑眩反应",
          infoTitle: "瞑眩症状",
        },
        2: {
          title: "入药反应",
          infoTitle: "反应症状",
        },
        3: {
          title: "新发症状",
          infoTitle: "症状描述",
        },
        4: {
          title: "停/续药安排",
          infoTitle: "瞑眩症状",
        },
      }[this.type];
    },
  },
  methods: {
    addEditInfo(row) {
      let addEditData = {};
      if (row) {
        if (this.type === 4) {
          addEditData = {
            ...row,
            startEndTime: [timeFormat(row.startTime, "yyyy-mm-dd")],
          };
        } else {
          addEditData = {
            ...row,
            startEndTime: [
              timeFormat(row.startTime, "yyyy-mm-dd"),
              timeFormat(row.endTime, "yyyy-mm-dd"),
            ],
          };
        }
      } else {
        addEditData = {
          type: this.type,
        };
      }
      this.goToEdit(addEditData);
    },
    goToEdit(params) {
      let type = {
        1: 7,
        2: 8,
        3: 9,
        4: 10,
      };
      this.$router.push({
        name: "EditMoreEffective",
        query: {
          type: type[this.type],
          id: this.$route.query.id,
        },
        params: {
          ...params,
          treatmentId: this.treatmentId,
          userMemberId: this.$route.query.id * 1,
        },
      });
    },
    getContent(item, type) {
      switch (type) {
        case 1:
          if (this.type !== 4)
            return `持续时间：${timeFormat(
              item.startTime,
              "yyyy.mm.dd"
            )}~${timeFormat(item.endTime, "yyyy.mm.dd")}`;
          else
            return `${item.type === 5 ? "续药" : "停药"}日期：${timeFormat(
              item.startTime,
              "yyyy年mm月dd日"
            )}`;
        case 2:
          if (this.type !== 4) return item.name || "-";
          else
            return `${item.type === 5 ? "续药" : "停药"}原因：${item.remark || '-'}`;
        case 3:
          if (this.type !== 4) return `备注：${item.remark || '-'}`;
          else
            return `${item.type === 5 ? "续药" : "停药"}实际${item.type === 5 ? "停止天数" : "服药疗程数"
              }：${item.stopNum || "-"}${this.type === 5 ? "天" : ""}`;
        default:
          return "";
      }
    },
  },
};
</script>
<style scoped lang="scss">
.f1 {
  flex: 1;
  flex-shrink: 0;
  width: 0;
}

.base-add-info {
  .base-top-header {
    display: flex;
    justify-content: space-between;
    padding: 15px 15px 11px;

    .base-top-title {
      font-size: 14px;
      font-weight: bold;
      color: #333333;
    }

    .base-top-button {
      background: #0082ef;
      border-radius: 4px;
      font-size: 14px;
      padding: 5px 18px;
      color: #fff;
    }
  }

  .base-item-box {
    background: #fff;
    padding: 15px;
    font-size: 14px;
    color: #333333;

    &.base-item-box:nth-child(even) {
      background: #eff3fb;
    }

    .item-info {
      display: flex;
      overflow: hidden;
      justify-content: space-between;

      &+.item-info {
        margin-top: 12px;
      }
    }
  }
}
</style>
